import {
  collection,
  doc,
  orderBy,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { Timestamp } from "firebase/firestore";
import { Map, OrderedMap } from "immutable";
import PropTypes from "prop-types";
import { collectionData, docData } from "rxfire/firestore";
import { Subject } from "rxjs";
import { map, tap } from "rxjs/operators";

import { firestore } from "../firebase";
import { createdAt } from "../lib/timestamp";

export const subject = new Subject();

let data = OrderedMap();
let syncAt = {};

export function clear() {
  data = OrderedMap();
  syncAt = {};
}

export function getData(projectId) {
  return (data.get(projectId) || Map()).toArray().map(([, item]) => item);
}

export const collectionName = (projectId) =>
  `projects/${projectId}/investment-rounds`;

export const propTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  project: PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string,
  }),
});

export const store = {
  list: (projectId) => {
    const investmentRoundsRef = query(
      collection(firestore, collectionName(projectId)),
      orderBy("updatedAt", "desc"),
      where("updatedAt", ">", Timestamp.fromMillis(syncAt[projectId] || 0))
    );

    return collectionData(investmentRoundsRef, { idField: "id" }).pipe(
      map((items) => {
        const newItems = OrderedMap(items.map((i) => [i.id, i]));
        const newData = newItems.mergeWith(
          (oldVal, newVal) => oldVal || newVal,
          data.get(projectId)
        );

        data = data.set(projectId, newData);

        return newData.toArray().map(([, item]) => item);
      }),
      tap(() => (syncAt[projectId] = new Date().getTime()))
    );
  },
  getByPath: (path, getData = true) => {
    const docRef = doc(firestore, path);

    return getData ? docData(docRef, { idField: "id" }) : docRef;
  },
  getById: (id, projectId, getData = true) => {
    const docRef = doc(firestore, collectionName(projectId), id);

    return getData ? docData(docRef, { idField: "id" }) : docRef;
  },
  create: (docData, project) => {
    const investmentRoundRef = doc(
      collection(firestore, collectionName(project.id))
    );
    docData.project = {
      slug: project.slug,
      name: project.projectName,
      companyName: project.companyName,
      specificSymbol: project.specificSymbol,
      bankAccountNumber: project.bankAccountNumber,
    };
    docData.availableShares = docData.poolSize;

    return setDoc(investmentRoundRef, { ...docData, ...createdAt() }).then(
      () => investmentRoundRef
    );
  },
};
